import React from 'react';
import { useUser } from '../store/useAuthStore';
import { NotificationPreferences } from '../components/NotificationPreferences';
import { Settings, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const NotificationSettings: React.FC = () => {
  const user = useUser();
  const navigate = useNavigate();

  const handleBack = () => {
    // Navigate back to appropriate dashboard based on role
    switch (user?.role) {
      case 'admin':
        navigate('/admin-dashboard');
        break;
      case 'distributor':
        navigate('/distributor-dashboard');
        break;
      case 'physician':
      case 'physician_readonly':
        navigate('/physician-dashboard');
        break;
      default:
        navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <button
                onClick={handleBack}
                className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Dashboard
              </button>
            </div>
            <div className="flex items-center">
              <Settings className="h-6 w-6 text-gray-400 mr-3" />
              <h1 className="text-xl font-semibold text-gray-900">Settings</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="space-y-8">
          {/* Page Title */}
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Notification Settings</h1>
            <p className="mt-2 text-gray-600">
              Manage how you receive notifications about payouts, orders, and account updates.
            </p>
          </div>

          {/* Notification Preferences Component */}
          <NotificationPreferences />

          {/* Additional Settings Placeholder */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <div className="flex items-center mb-4">
              <Settings className="h-5 w-5 text-gray-400 mr-2" />
              <h3 className="text-lg font-medium text-gray-900">Other Settings</h3>
            </div>
            <p className="text-gray-600">
              Additional account and system settings will be available here in future updates.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
